<ag-grid-angular
  class="ag-theme-wilson list-height"
  [defaultColDef]="defaultColDef"
  [gridOptions]="gridOptions"
  [components]="components"
  [columnDefs]="columnDefs"
  (gridReady)="onGridReady($event)"
>
</ag-grid-angular>

@let isDrawerVisible = isDrawerVisible$ | async;
@let qualificationDetails = qualificationDetails$ | async;
@let employee = employee$ | async;
@let canReadSharedUserQualificationV2Attachments =
  can(RoleAction.ReadShared, RolePermissionSubject.UserQualificationV2);
<wilson-qualification-details-drawer
  [isDrawerVisible]="isDrawerVisible || false"
  [employee]="employee"
  [qualificationDetails]="qualificationDetails"
  [canReadUserQualificationV2Attachments]="
    canReadSharedUserQualificationV2Attachments
  "
  (closeDrawer)="handleOnCloseDetailsDrawer()"
></wilson-qualification-details-drawer>
